import { SimpleSwapExactInput } from './actions/SimpleSwapExactInput';
import { SimpleSwapExactOutput } from './actions/SimpleSwapExactOutput';
import { ExactInputSingle } from './actions/ExactInputSingle';
import { ExactInput } from './actions/ExactInput';
import { SimpleSwapExactInputSwapRouter02 } from './actions/SimpleSwapExactInputSwapRouter02';
import { SimpleSwapExactOutputSwapRouter02 } from './actions/SimpleSwapExactOutputSwapRouter02';
import { ExactInputSingleSwapRouter02 } from './actions/ExactInputSingleSwapRouter02';
var actions = {
    ExactInput: ExactInput,
    // ExactOutput,
    // ExactOutputSingle,
    // Mint,
    // Burn,
    // IncreaseLiquidity,
    // DecreaseLiquidity,
    // Collect,
    SimpleSwapExactInput: SimpleSwapExactInput,
    SimpleSwapExactOutput: SimpleSwapExactOutput,
    ExactInputSingle: ExactInputSingle,
    SimpleSwapExactInputSwapRouter02: SimpleSwapExactInputSwapRouter02,
    SimpleSwapExactOutputSwapRouter02: SimpleSwapExactOutputSwapRouter02,
    ExactInputSingleSwapRouter02: ExactInputSingleSwapRouter02
};
var getters = {
// Positions,
// ProtocolFees,
// Slot0,
// Ticks,
};
var UniswapV3 = {
    actions: actions,
    getters: getters,
};
export { UniswapV3 };
